var exports = {
  "u3": "LabelTransition__vifgU2",
  "Cq": "ExpiredActionRow__PM2ZLf",
  "v0": "OpeningLabel__LQuney",
  "Wk": "ExpiredRetryButton__uGLYir",
  "fd": "DownloadButton__dOUOE6",
  "xz": "ExpiredIcon__pOA47X",
  "RH": "ExpiredContent__L10G4r",
  "k7": "ExpiredDescription__Q4SmHt",
  "fc": "OpeningWord__8DLyNM",
  "Gx": "OpeningWordShimmer__n-QTeJ",
  "fV": "OpeningWordInner__ZD3Uzg",
};

module.exports = exports;
